module.exports = __webpack_public_path__ + "img/calendar-check.db6e2802.svg";